import {
    Box,
    TableSortLabel,
    TextField,
    BoxProps,
    Button,
    TextFieldProps,
    SelectChangeEvent,
    Checkbox,
    FormControl,
    FormControlProps,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    TableContainerProps,
    useTheme,
    Typography,
    TypographyProps,
    Chip,
} from "@mui/material";
import {
    GridColumnVisibilityModel,
    GridPaginationModel,
    GridToolbar,
    GridToolbarColumnsButton,
    GridToolbarContainer,
} from "@mui/x-data-grid";
import DataTable from "components/formsUI/DataTable";
import React, { useEffect, MouseEvent, ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import * as applicationService from "services/application-service";
import * as processorService from "services/processor-service";
import * as departmentService from "services/department-service";
import * as locationService from "services/location-service";
import * as authenticationService from "services/AuthenticationService";
import * as userService from "services/identityUser-service";
import { statusStyleApplication } from "utilities/colorHelper";
import {
    getLocalStorage,
    getSessionStorage,
    parseSessionStorage,
    pasrseLocalStorage,
} from "utilities/sessionStorage";

import * as Styles from "pages/employee/requests/listRequests/listRequests.styles";
import dayjs from "dayjs";
import Card, { CardProps } from "@mui/material/Card";
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "contexts/authContext";
import "dayjs/locale/nl";
import "dayjs/locale/fr";
import "dayjs/locale/en";
import DatePicker from "components/formsUI/DatePicker/DatePicker";

interface filter {
    dateSubmission: Date | null | undefined;
    lastModificationTime: Date | null | undefined;
    dateFrom: Date | null | undefined;
    department: string;
    organisation: string;
    status: string[];
    referenceCode: string;
    requester: string;
    processor: string;
    order: "asc" | "desc";
    orderBy: string;
    currentPage: number;
    rowsPerPage: number;
    locations: string[];
    // count: number;
}

const initialColumnVisibility: { [key: string]: boolean } = {
    department: false,
    lastChange: false,
    locations: false,
};

const ListRequests = () => {
    const {
        t,
        i18n: { language },
    } = useTranslation();
    const navigate = useNavigate();
    const theme = useTheme();
    const { user, checkAuth } = useAuthContext();
    const [sessionStorageComplete, setSessionStorageComplete] =
        React.useState<boolean>(false);

    // Error
    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");

    const showError = (message: string) => {
        setErrorMessage(message);
        setShowErrorMessage(true);
    };

    // Table
    const [requests, setRequests] = React.useState<ApplicationPagedDTO[]>([]);
    const [currentPage, setCurrentPage] = React.useState<number>(0);
    const [rowsPerPage, setRowsPerPage] = React.useState<number>(25);
    const [count, setCount] = React.useState<number>(0);
    const [headers, setHeaders] = React.useState<{ [key: string]: boolean }>(
        initialColumnVisibility,
    );

    const [isLoading, setIsLoading] = React.useState(true);
    const [filtersChanged, setFiltersChanged] = React.useState(false);
    const [filtersChangedDate, setFiltersChangedDate] = React.useState("");

    const [order, setOrder] = React.useState<"asc" | "desc">("desc");
    const [orderBy, setOrderBy] = React.useState("creationTime");
    const [dateFrom, setDateFrom] = React.useState<Date | undefined | null>(
        null,
    );
    const [dateSubmission, setDateSubmission] = React.useState<
        Date | undefined | null
    >(null);
    const [requester, setRequester] = React.useState("");
    const [processor, setProcessor] = React.useState("");
    const [processors, setProcessors] = React.useState<Processor[]>([]);
    const [referenceCode, setReferenceCode] = React.useState("");
    const [initial, setInitial] = React.useState(true);
    const [location, setLocation] = React.useState<string[]>([]);

    const [departments, setDepartments] = React.useState<string[]>([]);
    const [selectedDepartments, setSelectedDepartments] = React.useState<
        string[]
    >([]);
    const [locations, setLocations] = React.useState<LocationList[]>([]);

    const [organisation, setOrganisation] = React.useState<string>("");
    const [organisations, setOrganisations] = React.useState<string[]>([]);
    const [selectedOrganisations, setSelectedOrganisations] = React.useState<
        string[]
    >([]);
    const [orgnisationDisabled, setOrgnisationDisabled] =
        React.useState<boolean>(false);
    const [lastModificationTime, setLastModificationTime] = React.useState<
        Date | undefined | null
    >(null);
    const [timeouts, setTimeouts] = React.useState<NodeJS.Timeout[]>([]);

    // --- Status multiselect setup ---
    const [status, setStatus] = React.useState<string[]>([]);
    const handleChange = (event: SelectChangeEvent<typeof status>) => {
        const {
            target: { value },
        } = event;
        const statuses = typeof value === "string" ? value.split(",") : value;
        setStatus(
            // On autofill we get a stringified value.
            statuses,
        );
        parse({ status: statuses });
        setFiltersChanged(true);
    };

    const handleReset = () => {
        setOrder("desc");
        setOrderBy("creationTime");
    };

    const handleLocationChange = (event: SelectChangeEvent<string[]>) => {
        const {
            target: { value },
        } = event;
        const locations = typeof value === "string" ? value.split(",") : value;
        setLocation(locations);
        parse({ locations: locations });
    };

    const handleOrgChange = (event: ChangeEvent<HTMLInputElement>): void => {
        const {
            target: { value },
        } = event;
        setOrganisation(value);
        parse({ organisation: value });
        setFiltersChanged(true);
    };

    const handleSelectOrgChange = (event: SelectChangeEvent<string[]>) => {
        const {
            target: { value },
        } = event;
        console.log(value);
        setSelectedOrganisations(
            typeof value === "string" ? value.split(",") : value,
        );
    };

    const handleDepartmentChange = (event: SelectChangeEvent<string[]>) => {
        const {
            target: { value },
        } = event;
        const departments =
            typeof value === "string" ? value.split(",") : value;
        setSelectedDepartments(departments);
        parse({ department: departments });
        setFiltersChanged(true);
    };

    const statuses = [
        "Ingediend",
        "In behandeling",
        "Positief",
        "Positief met waarschuwing",
        "Negatief",
        "Onvolledig",
        "Opgestart",
    ];

    const fetchRequests = (
        currentPage: number,
        rowsPerPage: number,
        order: string,
        orderBy: string,
    ) => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setRequests([]);
        setIsLoading(true);
        var statusJoin = status.join(", ");
        var locationsJoin = location.join(",");
        const departments = selectedDepartments.join(",");
        const organisationsJoin = selectedOrganisations.join(",");
        applicationService
            .getApplications(
                currentPage + 1,
                rowsPerPage,
                order,
                orderBy,
                requester,
                processor,
                statusJoin,
                dateFrom,
                referenceCode,
                dateSubmission,
                departments,
                selectedOrganisations.length > 0
                    ? organisationsJoin
                    : organisation,
                locationsJoin,
                lastModificationTime,
                orgnisationDisabled,
            )
            .then((res: ApplicationsPagedResponse) => {
                setIsLoading(false);
                setFiltersChanged(false);
                setCount(res.rowCount);
                setFiltersChangedDate("");
                const results = res.results;
                if (results && results.length <= 0) {
                    setRequests([]);
                } else {
                    setRequests(results);
                }
            })
            .catch((err) => {
                setIsLoading(false);
                const {
                    response: {
                        data: { error },
                    },
                } = err;
                if (error === undefined) {
                    showError(`${t("requests.error")}`);
                    return;
                }
                const code = error.code as number;

                if (code == 401) {
                    showError(`${t("requests.unauthorized")}`);
                } else {
                    showError(`${t("requests.error")}`);
                }
            });
    };

    const fethProcessors = () => {
        if (orgnisationDisabled) return;
        setErrorMessage("");
        setShowErrorMessage(false);
        setIsLoading(true);
        processorService
            .getProcessors("Processor")
            .then((res: Processor[]) => {
                setProcessors(res);
            })
            .catch((error: AxiosError<Error>) => {
                showError(`${t("errors.500")}`);
            });
    };

    const checkKeyEnter = (event: React.KeyboardEvent) => {
        if (event.key === "Enter") {
            // fetchRequests(currentPage, rowsPerPage, order, orderBy);
            debounce();
        }
    };

    const fetchLocations = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        locationService
            .getLocations()
            .then((res: LocationList[]) => {
                setLocations(res);
            })
            .catch((error: AxiosError<Error>) => {
                showError(`${t("certificates.error")}`);
            });
    };

    useEffect(() => {
        if (initial && !sessionStorageComplete) {
            const data = getSessionStorage<filter>("requests");
            if (data !== null) {
                if (data.lastModificationTime)
                    setLastModificationTime(data.lastModificationTime);
                if (data.dateSubmission) setDateSubmission(data.dateSubmission);
                if (data.dateFrom) setDateFrom(data.dateFrom);
                if (data.department)
                    setSelectedDepartments(
                        typeof data.department === "string"
                            ? data.department.split(",")
                            : data.department,
                    );
                if (data.organisation) setOrganisation(data.organisation);
                if (data.status) setStatus(data.status);
                if (data.referenceCode) setReferenceCode(data.referenceCode);
                if (data.requester) setRequester(data.requester);
                if (data.processor) setProcessor(data.processor);
                if (data.order) setOrder(data.order);
                if (data.orderBy) setOrderBy(data.orderBy);
                if (data.currentPage) setCurrentPage(data.currentPage);
                if (data.rowsPerPage) setRowsPerPage(data.rowsPerPage);
                setSessionStorageComplete(true);
            } else {
                setSessionStorageComplete(true);
            }
            getOrganisations();
            const headers = getLocalStorage<{ [key: string]: boolean }>(
                "requests",
            );
            if (headers) setHeaders(headers);
        }
        if (sessionStorageComplete) {
            debounce();
            if (departments.length <= 0) {
                departmentService.getDepartmentNames().then((res: string[]) => {
                    setDepartments([...res]);
                });
            }
        }
    }, [
        dateSubmission,
        dateFrom,
        selectedDepartments,
        selectedOrganisations,
        organisation,
        status,
        referenceCode,
        location,
        requester,
        processor,
        order,
        orderBy,
        currentPage,
        rowsPerPage,
        lastModificationTime,
        sessionStorageComplete,
    ]);

    const debounce = () => {
        timeouts.forEach((timeout) => {
            clearTimeout(timeout);
            clearInterval(timeout);
        });
        setTimeouts([]);
        const _timeout = setTimeout(() => {
            getAllInfo();
        }, 500);
        setTimeouts([...timeouts, _timeout]);
    };

    const getOrganisations = () => {
        setOrgnisationDisabled(false);
        if (checkAuth(["External"]) && !checkAuth(["Employee"])) {
            userService.getCompanyFromUser().then((res: Company[]) => {
                console.log(res);
                if (res.length <= 0) {
                    setOrgnisationDisabled(true);
                    return;
                }
                if (res.length == 1) {
                    setOrganisation(
                        res.map((company: Company) => company.name).join(", "),
                    );
                    setOrgnisationDisabled(true);
                } else {
                    setSelectedOrganisations(
                        res.map((company: Company) => company.name),
                    );
                    setOrganisations(
                        res.map((company: Company) => company.name),
                    );
                }
            });
        }
    };

    React.useEffect(() => {
        if (user !== null) getOrganisations();
    }, [user]);

    const getAllInfo = () => {
        if (initial) {
            fethProcessors();
            fetchLocations();
            setInitial(false);
        }
        if (locations.length === 0) {
            fetchLocations();
        }
        if (processors.length === 0) {
            fethProcessors();
        }
        if (filtersChangedDate === "") {
            fetchRequests(currentPage, rowsPerPage, order, orderBy);
        } else {
            var temp = null;
            if (filtersChangedDate === "dateSubmission" && dateSubmission)
                temp = new Date(dateSubmission).getTime();
            else if (filtersChangedDate === "dateFrom" && dateFrom)
                temp = new Date(dateFrom).getTime();
            else if (
                filtersChangedDate === "modification" &&
                lastModificationTime
            )
                temp = new Date(lastModificationTime).getTime();
            if (
                (temp && !isNaN(temp)) ||
                (filtersChangedDate === "dateSubmission" &&
                    dateSubmission === null) ||
                (filtersChangedDate === "dateFrom" && dateFrom === null) ||
                (filtersChangedDate === "modification" &&
                    lastModificationTime === null)
            ) {
                setFiltersChangedDate("");
                fetchRequests(currentPage, rowsPerPage, order, orderBy);
            }
        }
    };

    const handleHeaderChange = (model: GridColumnVisibilityModel) => {
        for (const key of Object.keys(model)) {
            const value = model[key] as boolean;
            if (value) continue;
            switch (key) {
                case "referenceCode":
                    setReferenceCode("");
                    break;
                case "creationTime":
                    setDateSubmission(null);
                    break;
                case "dateFrom":
                    setDateFrom(null);
                    break;
                case "requester":
                    setRequester("");
                    break;
                case "processor":
                    setProcessor("");
                    break;
                case "organization":
                    setOrganisation("");
                    getOrganisations();
                    break;
                case "department":
                    setSelectedDepartments([]);
                    break;
                case "lastChange":
                    setLastModificationTime(null);
                    break;
                case "locations":
                    setLocation([]);
                    break;
                case "status":
                    setStatus([]);
                    break;
            }
        }
        pasrseLocalStorage<GridColumnVisibilityModel>("requests", model);
        setHeaders(model);
    };

    const handleFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === "requester") {
            setRequester(event.target.value);
            parse({ requester: event.target.value });
        } else if (event.target.id === "processor") {
            setProcessor(event.target.value);
            parse({ processor: event.target.value });
        } else if (event.target.id === "referenceCode") {
            setReferenceCode(event.target.value);
            parse({ referenceCode: event.target.value });
        }
        setCurrentPage(0);
        setFiltersChanged(true);
    };

    const handleDateFilterChange = (
        date: Date | null | undefined,
        keyboardInputValue: string | undefined,
        field: "dateSubmission" | "dateFrom" | "modification",
    ) => {
        if (field === "dateSubmission") {
            setFiltersChangedDate("dateSubmission");
            setDateSubmission(date);
            parse({ dateSubmission: date });
        } else if (field === "dateFrom") {
            setFiltersChangedDate("dateFrom");
            setDateFrom(date);
            parse({ dateFrom: date });
        } else if (field === "modification") {
            setFiltersChangedDate("modification");
            setLastModificationTime(date);
            parse({ lastModificationTime: date });
        }

        setCurrentPage(0);
        setFiltersChanged(true);
    };

    const handleRequestSort = (property: string) => {
        if (orderBy === property) {
            if (order === "asc") {
                setOrder("desc");
                parse({ order: "desc" });
            } else {
                setOrder("asc");
                parse({ order: "asc" });
            }
            setCurrentPage(0);
        } else {
            setOrderBy(property);
            setOrder("desc");
            parse({ orderBy: property, order: "desc" });
            setCurrentPage(0);
        }
    };

    const handleChangePage = (event: MouseEvent | null, pageNr: number) => {
        setCurrentPage(pageNr);
        parse({ currentPage: pageNr });
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        parse({ rowsPerPage: parseInt(event.target.value, 10) });
        setCurrentPage(0);
    };

    const handleClickRequest = (request: ApplicationPagedDTO) => {
        navigate(`${request.id}`, { state: processors });
    };

    const checkFilterUpdateData = () => {};

    const updatePagination = (model: GridPaginationModel) => {
        const { pageSize, page } = model;
        setRowsPerPage(pageSize);
        setCurrentPage(page);
        parse({ currentPage: page, rowsPerPage: pageSize });
    };

    const parse = (filter: { [key: string]: any }): void => {
        const obj = {
            dateSubmission:
                "dateSubmission" in filter
                    ? filter.dateSubmission
                    : dateSubmission,
            lastModificationTime:
                "lastModificationTime" in filter
                    ? filter.lastModificationTime
                    : lastModificationTime,
            dateFrom: "dateFrom" in filter ? filter.dateFrom : dateFrom,
            department:
                "department" in filter
                    ? filter.department
                    : selectedDepartments,
            organisation:
                "organisation" in filter ? filter.organisation : organisation,
            status: "status" in filter ? filter.status : status,
            referenceCode:
                "referenceCode" in filter
                    ? filter.referenceCode
                    : referenceCode,
            requester: "requester" in filter ? filter.requester : requester,
            processor: "processor" in filter ? filter.processor : processor,
            order: "order" in filter ? filter.order : order,
            orderBy: "orderBy" in filter ? filter.orderBy : orderBy,
            currentPage:
                "currentPage" in filter ? filter.currentPage : currentPage,
            rowsPerPage:
                "rowsPerPage" in filter ? filter.rowsPerPage : rowsPerPage,
            locations: "locations" in filter ? filter.location : location,
        };
        parseSessionStorage<filter>("requests", obj);
    };

    // --- Props ---
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const tableStatusFilterProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };
    const tableFilterProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    const listRequestsWrapperProps: CardProps = {
        sx: Styles.listRequestsWrapper(theme),
    };

    const listRequestsTitleProps: TypographyProps = {
        variant: "h4",
        sx: Styles.listRequestsTitle(theme),
    };

    const titleWrapperProps: BoxProps = {
        sx: Styles.titleWrapper(theme),
    };

    const tableContainerProps: TableContainerProps = {
        sx: Styles.tableContainer(theme),
    };

    const tableSearchProps: BoxProps = {
        sx: Styles.tableSearch(theme),
    };

    const tableTextFieldProps: TextFieldProps = {
        sx: Styles.tableTextField(theme),
    };

    const statusFilterProps: FormControlProps = {
        size: "small",
        sx: Styles.statusFilter(theme),
    };

    const organisationsFilterProps: FormControlProps = {
        size: "small",
        sx: Styles.organisationsFilter(theme),
    };

    return (
        <Card {...listRequestsWrapperProps}>
            <Box {...titleWrapperProps}>
                <Typography {...listRequestsTitleProps}>
                    {t("requests.overview")}
                </Typography>
                {showErrorMessage && (
                    <Box color="error.main">
                        <Box>{errorMessage}</Box>
                        <Button
                            sx={{ marginTop: "5px" }}
                            color="error"
                            variant="outlined"
                            onClick={() => {
                                getAllInfo();
                            }}
                        >
                            {t("requests.errorButton")}
                        </Button>
                    </Box>
                )}
            </Box>
            <Box {...tableContainerProps}>
                <DataTable
                    rows={requests}
                    columns={[
                        {
                            field: "referenceCode",
                            headerName: t("requestsTableHeader.referenceCode"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <TextField
                                        {...tableTextFieldProps}
                                        id="referenceCode"
                                        label={t(
                                            "requestsTableHeader.referenceCode",
                                        )}
                                        size="small"
                                        onChange={handleFilterChange}
                                        value={referenceCode}
                                        onBlur={() => checkFilterUpdateData()}
                                        onKeyDown={checkKeyEnter}
                                    />
                                    <TableSortLabel
                                        active={orderBy === "referenceCode"}
                                        direction={
                                            orderBy === "referenceCode"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort("referenceCode")
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                        },
                        {
                            field: "creationTime",
                            headerName: t("requestsTableHeader.submissionDate"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <DatePicker
                                        label={t(
                                            "requestsTableHeader.submissionDate",
                                        )}
                                        value={dateSubmission}
                                        onChange={(
                                            newValue,
                                            keyboardInputValue,
                                        ) => {
                                            handleDateFilterChange(
                                                newValue,
                                                keyboardInputValue,
                                                "dateSubmission",
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                {...tableTextFieldProps}
                                            />
                                        )}
                                    />

                                    <TableSortLabel
                                        active={orderBy === "creationTime"}
                                        direction={
                                            orderBy === "creationTime"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort("creationTime")
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                            // valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY')
                            valueFormatter: (params) => {
                                try {
                                    var date = new Date(params.value);
                                    return `${("0" + date.getDate()).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
                                } catch (error) {
                                    return "";
                                }
                            },
                        },
                        {
                            field: "dateFrom",
                            headerName: t("requestsTableHeader.startDate"),
                            renderHeader: () => {
                                return (
                                    <Box {...tableSearchProps}>
                                        <DatePicker
                                            label={t(
                                                "requestsTableHeader.startDate",
                                            )}
                                            value={dateFrom}
                                            onChange={(
                                                newValue,
                                                keyboardInputValue,
                                            ) => {
                                                handleDateFilterChange(
                                                    newValue,
                                                    keyboardInputValue,
                                                    "dateFrom",
                                                );
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    size="small"
                                                    {...tableTextFieldProps}
                                                />
                                            )}
                                            inputFormat="DD/MM/YYYY"
                                        />

                                        <TableSortLabel
                                            active={orderBy === "dateFrom"}
                                            direction={
                                                orderBy === "dateFrom"
                                                    ? order
                                                    : "desc"
                                            }
                                            onClick={() =>
                                                handleRequestSort("dateFrom")
                                            }
                                        ></TableSortLabel>
                                    </Box>
                                );
                            },
                            // valueFormatter: (params) => dayjs(params.value).format('DD/MM/YYYY')
                            valueFormatter: (params) => {
                                try {
                                    var date = new Date(params.value);
                                    return `${("0" + date.getDate()).slice(-2)}/${("0" + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
                                } catch (error) {
                                    return "";
                                }
                            },
                        },
                        {
                            field: "locations",
                            headerName: t("certificatesTableHeader.locations"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <FormControl {...statusFilterProps}>
                                        <InputLabel id="locations-label">
                                            {t(
                                                "certificatesTableHeader.locations",
                                            )}
                                        </InputLabel>
                                        <Select
                                            labelId="locations-label"
                                            id="locations"
                                            multiple
                                            value={location}
                                            autoWidth
                                            onChange={handleLocationChange}
                                            input={
                                                <OutlinedInput
                                                    label={t(
                                                        "certificatesTableHeader.locations",
                                                    )}
                                                />
                                            }
                                            renderValue={(selected) =>
                                                selected.join(", ")
                                            }
                                            MenuProps={tableFilterProps}
                                            onClose={() => {
                                                setCurrentPage(0);
                                                checkFilterUpdateData();
                                            }}
                                            onBlur={(e) => e.stopPropagation()}
                                        >
                                            {locations.map((item) => (
                                                <MenuItem
                                                    key={item.id}
                                                    value={item.name}
                                                    sx={{
                                                        paddingRight: "15px",
                                                    }}
                                                >
                                                    <Checkbox
                                                        checked={
                                                            location.indexOf(
                                                                item.name,
                                                            ) > -1
                                                        }
                                                    />
                                                    <ListItemText
                                                        primary={item.name}
                                                    />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            ),
                            renderCell: (params) => (
                                <Box
                                    sx={{
                                        paddingTop: "0.50rem",
                                        paddingBottom: "0.50rem",
                                    }}
                                >
                                    {params.value.map((location: any) => (
                                        <Box
                                            key={location.id}
                                            sx={{ textAlign: "center" }}
                                        >
                                            {location.name}
                                        </Box>
                                    ))}
                                </Box>
                            ),
                        },
                        {
                            field: "requester",
                            headerName: t("requestsTableHeader.requester"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <TextField
                                        {...tableTextFieldProps}
                                        id="requester"
                                        label={t(
                                            "requestsTableHeader.requester",
                                        )}
                                        size="small"
                                        onChange={handleFilterChange}
                                        value={requester}
                                        onBlur={() => checkFilterUpdateData()}
                                        onKeyDown={checkKeyEnter}
                                    />
                                    <TableSortLabel
                                        active={
                                            orderBy === "applicant.firstName"
                                        }
                                        direction={
                                            orderBy === "applicant.firstName"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort(
                                                "applicant.firstName",
                                            )
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                            renderCell: (params) => (
                                <Box>
                                    {params.row.firstNameRequester}{" "}
                                    {params.row.lastNameRequester}
                                </Box>
                            ),
                        },
                        {
                            field: "processor",
                            headerName: t("requestsTableHeader.processor"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <TextField
                                        {...tableTextFieldProps}
                                        id="processor"
                                        label={t(
                                            "requestsTableHeader.processor",
                                        )}
                                        size="small"
                                        onChange={handleFilterChange}
                                        value={processor}
                                        onBlur={() => checkFilterUpdateData()}
                                        onKeyDown={checkKeyEnter}
                                    />
                                    <TableSortLabel
                                        active={orderBy === "processor"}
                                        direction={
                                            orderBy === "processor"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort("processor")
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                            renderCell: (params) => (
                                <Box>
                                    {params.row.firstNameProcessor}{" "}
                                    {params.row.lastNameProcessor}
                                </Box>
                            ),
                        },
                        {
                            field: "department",
                            headerName: t("requestsTableHeader.department"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <FormControl {...statusFilterProps}>
                                        <InputLabel id="department-label">
                                            {t(
                                                "requestsTableHeader.department",
                                            )}
                                        </InputLabel>
                                        <Select
                                            labelId="department-label"
                                            multiple
                                            value={selectedDepartments}
                                            onChange={handleDepartmentChange}
                                            renderValue={(selected) =>
                                                selected.join(", ")
                                            }
                                            input={
                                                <OutlinedInput
                                                    label={t(
                                                        "requestsTableHeader.department",
                                                    )}
                                                />
                                            }
                                            MenuProps={tableStatusFilterProps}
                                            onClose={() => {
                                                setCurrentPage(0);
                                                checkFilterUpdateData();
                                            }}
                                        >
                                            {departments.map((department) => (
                                                <MenuItem
                                                    key={department}
                                                    value={department}
                                                >
                                                    <Checkbox
                                                        checked={
                                                            selectedDepartments.indexOf(
                                                                department,
                                                            ) > -1
                                                        }
                                                    />
                                                    <ListItemText
                                                        primary={department}
                                                    />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <TableSortLabel
                                        active={orderBy === "department"}
                                        direction={
                                            orderBy === "department"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort("department")
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                        },
                        {
                            field: "organization",
                            headerName: t("requestsTableHeader.org"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    {organisations.length > 0 ? (
                                        <FormControl
                                            {...organisationsFilterProps}
                                        >
                                            <InputLabel id="organisations-label">
                                                {t("requestsTableHeader.org")}
                                            </InputLabel>
                                            <Select
                                                labelId="organisations-label"
                                                multiple
                                                value={selectedOrganisations}
                                                onChange={handleSelectOrgChange}
                                                renderValue={(selected) =>
                                                    selected.join(", ")
                                                }
                                                input={
                                                    <OutlinedInput
                                                        label={t(
                                                            "requestsTableHeader.org",
                                                        )}
                                                    />
                                                }
                                            >
                                                {organisations.map(
                                                    (organisation) => (
                                                        <MenuItem
                                                            key={organisation}
                                                            value={organisation}
                                                        >
                                                            <Checkbox
                                                                checked={selectedOrganisations.includes(
                                                                    organisation,
                                                                )}
                                                            />
                                                            <ListItemText
                                                                primary={
                                                                    organisation
                                                                }
                                                            />
                                                        </MenuItem>
                                                    ),
                                                )}
                                            </Select>
                                        </FormControl>
                                    ) : (
                                        <TextField
                                            {...tableTextFieldProps}
                                            id="organisation"
                                            label={t("requestsTableHeader.org")}
                                            size="small"
                                            onChange={handleOrgChange}
                                            value={organisation}
                                            disabled={orgnisationDisabled}
                                            onBlur={() =>
                                                checkFilterUpdateData()
                                            }
                                            onKeyDown={checkKeyEnter}
                                        />
                                    )}
                                    <TableSortLabel
                                        active={orderBy === "organisation"}
                                        direction={
                                            orderBy === "organisation"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort("organisation")
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                        },
                        {
                            field: "lastChange",
                            headerName: t(
                                "requestsTableHeader.lastModificationTime",
                            ),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <DatePicker
                                        label={t(
                                            "requestsTableHeader.lastModificationTime",
                                        )}
                                        value={lastModificationTime}
                                        onChange={(
                                            newValue,
                                            keyboardInputValue,
                                        ) => {
                                            handleDateFilterChange(
                                                newValue,
                                                keyboardInputValue,
                                                "modification",
                                            );
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                size="small"
                                                {...tableTextFieldProps}
                                            />
                                        )}
                                        inputFormat="DD/MM/YYYY"
                                    />

                                    <TableSortLabel
                                        active={orderBy === "lastChange"}
                                        direction={
                                            orderBy === "lastChange"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort("lastChange")
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                            renderCell: (params) => (
                                <Box>
                                    {params.row.lastChange
                                        ? dayjs(params.row.lastChange).format(
                                              "DD/MM/YYYY",
                                          )
                                        : dayjs(params.row.creationTime).format(
                                              "DD/MM/YYYY",
                                          )}
                                </Box>
                            ),
                        },
                        {
                            field: "status",
                            headerName: t("requestsTableHeader.status"),
                            renderHeader: () => (
                                <Box {...tableSearchProps}>
                                    <FormControl {...statusFilterProps}>
                                        <InputLabel id="status-label">
                                            {t("requestsTableHeader.status")}
                                        </InputLabel>
                                        <Select
                                            labelId="status-label"
                                            id="status"
                                            multiple
                                            value={status}
                                            onChange={handleChange}
                                            input={
                                                <OutlinedInput
                                                    label={t(
                                                        "requestsTableHeader.status",
                                                    )}
                                                />
                                            }
                                            renderValue={(selected) =>
                                                selected
                                                    .map((state) => t(state))
                                                    .join(", ")
                                            }
                                            MenuProps={tableStatusFilterProps}
                                            onClose={() => {
                                                setCurrentPage(0);
                                                checkFilterUpdateData();
                                            }}
                                            onBlur={(e) => {
                                                e.stopPropagation();
                                            }}
                                        >
                                            {statuses.map((name) => (
                                                <MenuItem
                                                    key={name}
                                                    value={name}
                                                >
                                                    <Checkbox
                                                        checked={
                                                            status.indexOf(
                                                                name,
                                                            ) > -1
                                                        }
                                                    />
                                                    <ListItemText
                                                        primary={t(name)}
                                                    />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <TableSortLabel
                                        active={orderBy === "status"}
                                        direction={
                                            orderBy === "status"
                                                ? order
                                                : "desc"
                                        }
                                        onClick={() =>
                                            handleRequestSort("status")
                                        }
                                    ></TableSortLabel>
                                </Box>
                            ),
                            renderCell: (params) => (
                                <Chip
                                    sx={{
                                        marginLeft: "10px",
                                        backgroundColor: statusStyleApplication(
                                            params.value,
                                        ),
                                        color: "white",
                                    }}
                                    label={t(params.value)}
                                    size="small"
                                />
                            ),
                        },
                    ]}
                    loading={isLoading}
                    rowCount={count}
                    updatePagination={updatePagination}
                    paginationModel={{
                        pageSize: rowsPerPage,
                        page: currentPage,
                    }}
                    onRowClick={(params) => handleClickRequest(params.row)}
                    onColumnVisibilityModelChange={handleHeaderChange}
                    columnVisibilityModel={headers}
                    initialColumnVisibility={initialColumnVisibility}
                    reset={handleReset}
                    autoHeight={["locations", "organization"]}
                />
            </Box>
        </Card>
    );
};

export default ListRequests;
